/* Vitalis — Figma "Vitalis — Site" */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const pad = (n) => String(n).padStart(2, '0');
  const store = {
    get(key) { try { return localStorage.getItem(key); } catch (e) { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }
  };

  /* Countdowns: data-vt-countdown="<ISO end>" or data-vt-evergreen="<hours>" (per visitor, restarts when over) */
  function countdownEnd(el) {
    const fixed = Date.parse(el.dataset.vtCountdown || '');
    if (fixed && fixed > Date.now()) return fixed;
    const hours = parseFloat(el.dataset.vtEvergreen || '0');
    if (!hours) {
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      return midnight.getTime();
    }
    const key = 'vt-cd-' + (el.dataset.vtKey || 'default');
    let end = parseInt(store.get(key) || '0', 10);
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600e3;
      store.set(key, String(end));
    }
    return end;
  }
  function initCountdowns() {
    const els = $$('[data-vt-countdown], [data-vt-evergreen]');
    if (!els.length) return;
    const ends = new Map(els.map((el) => [el, countdownEnd(el)]));
    const tick = () => {
      els.forEach((el) => {
        let left = Math.max(0, Math.floor((ends.get(el) - Date.now()) / 1000));
        if (left === 0) { ends.set(el, countdownEnd(el)); left = Math.max(0, Math.floor((ends.get(el) - Date.now()) / 1000)); }
        const d = Math.floor(left / 86400);
        const h = Math.floor((left % 86400) / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        const parts = { d, dj: d + ' j', h: pad(h), m: pad(m), s: pad(s), H: pad(d * 24 + h) };
        $$('[data-vt-unit]', el).forEach((u) => { u.textContent = parts[u.dataset.vtUnit]; });
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* Marquee: duplicate content so it loops when it overflows */
  function initMarquees() {
    $$('[data-vt-marquee]').forEach((wrap) => {
      const track = $('.vt-marquee__track', wrap);
      if (!track || wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const fill = () => {
        const original = $$('[data-vt-original]', track);
        $$('[data-vt-clone]', track).forEach((n) => n.remove());
        wrap.classList.remove('is-moving');
        if (track.scrollWidth <= wrap.clientWidth || wrap.dataset.vtMarquee === 'static') return;
        const copies = Math.ceil(wrap.clientWidth / track.scrollWidth) + 1;
        for (let i = 0; i < copies; i++) {
          original.forEach((n) => {
            const c = n.cloneNode(true);
            c.removeAttribute('data-vt-original');
            c.setAttribute('data-vt-clone', '');
            c.setAttribute('aria-hidden', 'true');
            track.appendChild(c);
          });
        }
        wrap.style.setProperty('--vt-marquee-speed', Math.max(20, track.scrollWidth / 60) + 's');
        wrap.classList.add('is-moving');
      };
      fill();
      let t;
      window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(fill, 200); });
    });
  }

  /* Mobile drawer menu */
  function initDrawer() {
    $$('[data-vt-drawer-open]').forEach((btn) => btn.addEventListener('click', () => {
      const d = $('[data-vt-drawer]');
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }));
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-vt-drawer-close]')) return;
      const d = $('[data-vt-drawer]');
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    });
  }

  /* Gallery */
  function initGalleries() {
    $$('[data-vt-gallery]').forEach((g) => {
      const main = $('.vt-gallery__main', g);
      const slides = $$('.vt-gallery__slide', g);
      const thumbs = $$('.vt-thumb', g);
      const show = (i) => {
        slides.forEach((s, j) => s.classList.toggle('is-active', i === j));
        thumbs.forEach((t, j) => { t.classList.toggle('is-active', i === j); t.setAttribute('aria-current', i === j ? 'true' : 'false'); });
        main.classList.toggle('is-first', i === 0);
        $$('video', g).forEach((v, j) => { if (!slides[i].contains(v)) v.pause(); else v.play && v.play().catch(() => {}); });
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
      let x0 = null;
      main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40) return;
        const cur = slides.findIndex((s) => s.classList.contains('is-active'));
        show((cur + (dx < 0 ? 1 : slides.length - 1)) % slides.length);
      });
    });
  }


  /* Grand jeu: optional phone saved as a customer tag "tel:+33..." (native phone field rejects duplicates) */
  function vtPhone(raw) {
    let v = raw.replace(/[\s.\-()]/g, '');
    if (/^00/.test(v)) v = '+' + v.slice(2);
    if (v.charAt(0) === '+') {
      let d = v.slice(1); if (!/^\d+$/.test(d)) return null;
      if (d.indexOf('330') === 0) d = '33' + d.slice(3);
      v = '+' + d;
    } else if (/^0\d{9}$/.test(v)) v = '+33' + v.slice(1);
    else if (/^[1-9]\d{8}$/.test(v)) v = '+33' + v;
    else return null;
    if (v.indexOf('+33') === 0) return /^\+33[1-9]\d{8}$/.test(v) ? v : null;
    return /^\+[1-9]\d{7,14}$/.test(v) ? v : null;
  }
  function initVip() {
    $$('[data-vt-phone]').forEach((phone) => {
      const form = phone.closest('form'); const tags = form && $('[data-vt-tags]', form);
      if (!tags) return;
      const base = tags.value;
      phone.addEventListener('input', () => phone.setCustomValidity(''));
      form.addEventListener('submit', (e) => {
        const raw = phone.value.trim(); tags.value = base;
        if (!raw) return;
        const n = vtPhone(raw);
        if (!n) { phone.setCustomValidity(phone.dataset.vtPhoneError || 'Numéro invalide'); phone.reportValidity(); e.preventDefault(); return; }
        tags.value = (base ? base + ', ' : '') + 'tel:' + n;
      });
    });
  }

  /* Side cart (Vitalis) */
  const cartEl = () => $('[data-vt-cart]');
  const cartSectionId = () => { const c = cartEl(); const w = c && c.closest('.shopify-section'); return w ? w.id.replace('shopify-section-', '') : null; };
  function openCart() {
    const c = cartEl(); if (!c) return false;
    c.classList.add('is-open'); c.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('vt-lock');
    return true;
  }
  function closeCart() {
    const c = cartEl(); if (!c) return;
    c.classList.remove('is-open'); c.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('vt-lock');
  }
  /* Apply cart drawer HTML returned with a Cart API call (?sections=) - no extra round-trips */
  function applyCartHtml(html) {
    const c = cartEl(); if (!c || !html) return false;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vt-cart]');
    if (!next) return false;
    c.innerHTML = next.innerHTML;
    const n = parseInt(next.dataset.count || '0', 10);
    c.dataset.count = n;
    $$('[data-vt-cart-count]').forEach((x) => { x.textContent = n > 0 ? n : ''; });
    return true;
  }
  async function renderCart() {
    const id = cartSectionId(); const c = cartEl();
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    $$('[data-vt-cart-count]').forEach((n) => { n.textContent = cart.item_count > 0 ? cart.item_count : ''; });
    if (!id || !c) return false;
    const html = (await (await fetch(`${window.location.pathname}?sections=${encodeURIComponent(id)}`)).json())[id];
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vt-cart]');
    if (next) c.innerHTML = next.innerHTML;
    return true;
  }
  async function refreshCart(open) {
    try {
      const ok = await renderCart();
      if (ok && open) openCart();
      return ok;
    } catch (e) { return false; }
  }
  function initCart() {
    document.addEventListener('click', async (e) => {
      if (e.target.closest('[data-vt-cart-open]')) { if (cartEl()) { e.preventDefault(); openCart(); } return; }
      if (e.target.closest('[data-vt-cart-close]')) { closeCart(); return; }
      const q = e.target.closest('[data-vt-qty]');
      if (!q || !cartEl()) return;
      const line = q.closest('[data-key]'); if (!line) return;
      const qty = parseInt(q.dataset.vtQty, 10);
      const updates = { [line.dataset.key]: qty };
      const kid = (n) => { try { return JSON.parse(n.dataset.kprops || '{}').id || ''; } catch (err) { return ''; } };
      const myKid = kid(line);
      if (qty === 0 && myKid) $$('[data-kprops]', cartEl()).forEach((l) => { if (kid(l) === myKid) updates[l.dataset.key] = 0; });
      cartEl().classList.add('is-loading');
      try {
        const id = cartSectionId();
        const r = await (await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates, sections: id ? [id] : undefined, sections_url: window.location.pathname }) })).json();
        if (!(r && r.sections && applyCartHtml(r.sections[id]))) await renderCart();
      }
      finally { const c = cartEl(); c && c.classList.remove('is-loading'); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); $$('dialog.vt-modal[open]').forEach((d) => d.close()); } });
  }

  /* Mega menu */
  function initMega() {
    const h = $('[data-vt-header]'); if (!h || !$('[data-vt-mega]', h)) return;
    let t;
    const open = (a) => { clearTimeout(t); h.classList.add('is-mega'); $$('[data-vt-mega-trigger]', h).forEach((x) => x.classList.toggle('is-hover', x === a)); };
    const close = () => { t = setTimeout(() => { h.classList.remove('is-mega'); $$('.is-hover', h).forEach((x) => x.classList.remove('is-hover')); }, 150); };
    $$('[data-vt-mega-trigger]', h).forEach((a) => { a.addEventListener('mouseenter', () => open(a)); a.addEventListener('focus', () => open(a)); });
    $$('.vt-nav a:not([data-vt-mega-trigger]), .vt-actions', h).forEach((a) => a.addEventListener('mouseenter', close));
    h.addEventListener('mouseleave', close);
    $('[data-vt-mega]', h).addEventListener('mouseenter', () => clearTimeout(t));
    $('[data-vt-mega]', h).addEventListener('focusout', (e) => { if (!h.contains(e.relatedTarget)) close(); });
  }

  /* Legal pages: table of contents (pages + Shopify policies) */
  function initLegal() {
    const pol = $('.shopify-policy__container');
    if (pol && !$('[data-vt-legal]')) {
      const title = $('.shopify-policy__title', pol); const body = $('.shopify-policy__body', pol) || pol;
      const sec = el('section', 'vt-s vt-legal'); sec.setAttribute('data-vt-legal', '');
      sec.innerHTML = '<div class="vt-in vt-legal__grid"><aside class="vt-legal__toc"><p>SOMMAIRE</p><ol data-vt-toc></ol></aside><article class="vt-legal__main"><nav class="vt-crumbs" aria-label="Fil d\'Ariane"><a href="/">Accueil</a><span aria-hidden="true">/</span><span></span></nav><h1 class="vt-legal__title"></h1><div class="vt-legal__body" data-vt-legal-body></div></article></div>';
      const t = (title ? title.textContent : document.title).trim();
      $('.vt-crumbs span:last-child', sec).textContent = t; $('.vt-legal__title', sec).textContent = t;
      $('[data-vt-legal-body]', sec).appendChild(body);
      pol.replaceWith(sec);
    }
    $$('[data-vt-legal]').forEach((sec) => {
      const toc = $('[data-vt-toc]', sec); const body = $('[data-vt-legal-body]', sec);
      if (!toc || !body || toc.children.length) return;
      if ($$('h2, h3', body).length < 3) {
        $$('p, div, span', body).forEach((n) => {
          if ($('p, div, span, h2, h3', n)) return;
          const txt = n.textContent.trim();
          const caps = /[A-ZÀ-Ü]{3}/.test(txt) && txt === txt.toUpperCase();
          if (txt.length > 2 && txt.length < 90 && (caps || /^(article\s+[0-9ivxlc]+|[0-9]{1,2}\s*[.)\-–]\s)/i.test(txt))) {
            const inline = n.tagName === 'SPAN';
            const h = document.createElement(inline ? 'span' : 'h2');
            h.className = 'vt-lh'; h.textContent = txt.replace(/\s*[-–:]\s*$/, ''); n.replaceWith(h);
          }
        });
      }
      $$('h2, h3, .vt-lh', body).filter((h) => h.tagName !== 'H3' || !$('h2, .vt-lh', body)).forEach((h, i) => {
        if (!h.id) h.id = 'section-' + (i + 1);
        const li = el('li'); const a = el('a', null, h.textContent.trim()); a.href = '#' + h.id; li.appendChild(a); toc.appendChild(li);
      });
    });
  }

  /* Packs + add to cart through Kaching Bundles' cart properties (keeps its discounts and free gifts) */
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + d;
    return (fmt || '{{amount_with_comma_separator}} €').replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount\s*\}\}/, v);
  };
  function initBuy() {
    $$('[data-vt-buy]').forEach((form) => {
      const btn = $('[data-vt-add]', form);
      const label = $('[data-vt-add-sub]', form);
      const err = $('[data-vt-error]', form);
      const update = () => {
        const pack = $('input[name="vt-pack"]:checked', form);
        if (pack && label) label.textContent = pack.dataset.cta || '';
        if (pack) $$('[data-vt-add-mirror]').forEach((m) => { m.textContent = pack.dataset.cta || ''; });
      };
      $$('input[name="vt-pack"]', form).forEach((i) => i.addEventListener('change', update));
      const want = new URLSearchParams(window.location.search).get('pack');
      const pre = want && $(`input[name="vt-pack"][value="${want}"]`, form);
      if (pre) { pre.checked = true; pre.dispatchEvent(new Event('change')); }
      update();
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const pack = $('input[name="vt-pack"]:checked', form);
        if (!pack) return;
        const variant = parseInt(form.dataset.variant, 10);
        const qty = parseInt(pack.dataset.qty, 10) || 1;
        const deal = form.dataset.kachingDeal;
        const bar = pack.dataset.bar;
        const items = [];
        const sid = Math.random().toString(36).slice(2, 6);
        if (deal && bar) {
          items.push({ id: variant, quantity: qty, properties: { __kaching_bundles: JSON.stringify({ deal, pp: parseInt(form.dataset.product, 10), main: true, id: sid, bid: bar }) } });
          $$('[data-gift-variant]', pack.closest('.vt-pack')).forEach((g) => {
            if (!g.dataset.giftVariant || !g.dataset.giftId) return;
            if (g.dataset.giftId === '+') { items.push({ id: parseInt(g.dataset.giftVariant, 10), quantity: 1 }); return; }
            items.push({ id: parseInt(g.dataset.giftVariant, 10), quantity: 1, properties: { __kaching_bundles: JSON.stringify({ id: sid, deal, gift: g.dataset.giftId }) } });
          });
        } else {
          items.push({ id: variant, quantity: qty });
        }
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        const drawer = cartEl(); const cartSid = cartSectionId();
        if (drawer) { drawer.classList.add('is-loading'); openCart(); }
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: cartSid ? [cartSid] : undefined, sections_url: window.location.pathname }) });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Erreur');
          if (!(data.sections && applyCartHtml(data.sections[cartSid]))) {
            const opened = await refreshCart(true);
            if (!opened) window.location.href = form.dataset.cartUrl || '/cart';
          }
        } catch (ex) {
          if (drawer) closeCart();
          if (err) { err.textContent = ex.message || 'Une erreur est survenue, réessayez.'; err.hidden = false; }
        } finally {
          btn.classList.remove('is-loading');
          if (drawer) drawer.classList.remove('is-loading');
        }
      });
    });
  }

  /* Reviews: filters, helpful votes, mobile dots, live Trustoo reviews */
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const reviewTags = (r) => {
    const c = (r.content || '').toLowerCase();
    const tags = [];
    if ((r.resources || []).length) tags.push('photos');
    if (r.star >= 5) tags.push('5');
    if (/repouss|pouss|densit|épais/.test(c)) tags.push('repousse');
    if (/chute|tomb|perd|perte/.test(c)) tags.push('chute');
    if (/accouch|post-?partum|grossesse|enfant/.test(c)) tags.push('post-partum');
    if (/calvitie|dégarn|golfe|tonsure|tempes/.test(c)) tags.push('calvitie');
    return tags.join(',');
  };
  const starsNode = (src, n, size, cls) => {
    const s = el('span', cls || 'vt-stars');
    for (let i = 0; i < n; i++) { const im = el('img'); im.src = src; im.alt = ''; im.width = size; im.height = size; s.appendChild(im); }
    return s;
  };
  function cardGrid(sec, r) {
    const d = sec.dataset;
    const name = (r.author || '').trim() || 'Cliente';
    const a = el('article', 'vt-review vt-review--live');
    a.dataset.tags = reviewTags(r);
    const res = (r.resources || []).filter((x) => x.resource_type === 1).slice(0, 2);
    if (res.length) {
      const ba = el('div', 'vt-review__ba' + (res.length === 1 ? ' vt-review__ba--one' : ''));
      res.forEach((x) => { const w = el('div'); w.setAttribute('data-vt-zoom', x.src || x.card_thumbnail_url || x.thumb_src); w.setAttribute('role', 'button'); w.tabIndex = 0; w.setAttribute('aria-label', 'Agrandir la photo de ' + name); const im = el('img'); im.src = x.card_thumbnail_url || x.thumb_src || x.src; im.alt = 'Photo de ' + name; im.loading = 'lazy'; w.appendChild(im); ba.appendChild(w); });
      a.appendChild(ba);
    }
    const head = el('div', 'vt-review__head');
    head.appendChild(el('span', 'vt-avatar', name.charAt(0).toUpperCase()));
    const who = el('div', 'vt-review__who');
    const nm = el('p', 'vt-review__name', name);
    const ver = el('span', 'vt-review__verified'); const vi = el('img'); vi.src = d.verifiedIcon; vi.alt = ''; vi.width = 13; vi.height = 13; ver.appendChild(vi); ver.appendChild(document.createTextNode(d.verified || 'Vérifié'));
    nm.appendChild(ver); who.appendChild(nm); who.appendChild(el('p', 'vt-review__src', 'Avis vérifié'));
    head.appendChild(who); head.appendChild(starsNode(d.star, r.star || 5, 13));
    a.appendChild(head);
    a.appendChild(starsNode(d.star, r.star || 5, 12, 'vt-review__stars-m'));
    a.appendChild(el('p', 'vt-review__text', (r.content || '').trim()));
    const am = el('div', 'vt-review__author-m');
    am.appendChild(el('span', 'vt-avatar', name.charAt(0).toUpperCase()));
    const ams = el('span'); ams.appendChild(el('b', null, name)); ams.appendChild(el('span', null, d.verifiedM || 'Achat vérifié')); am.appendChild(ams);
    a.appendChild(am);
    const h = el('button', 'vt-review__helpful'); h.type = 'button'; h.dataset.count = r.likes_count || 0;
    h.appendChild(document.createTextNode((d.helpful || 'Utile') + ' · ')); h.appendChild(el('span', null, String(r.likes_count || 0))).setAttribute('data-n', '');
    a.appendChild(h);
    return a;
  }
  function cardList(sec, r) {
    const d = sec.dataset;
    const name = (r.author || '').trim() || 'Cliente';
    const a = el('article', 'vt-review vt-ritem');
    a.dataset.tags = reviewTags(r);
    const head = el('div', 'vt-ritem__head');
    head.appendChild(el('span', 'vt-avatar', name.charAt(0).toUpperCase()));
    const w = el('div');
    const nm = el('p', 'vt-review__name', name);
    const ver = el('span', 'vt-review__verified'); const vi = el('img'); vi.src = d.verifiedIcon; vi.alt = ''; vi.width = 12; vi.height = 12; ver.appendChild(vi); ver.appendChild(document.createTextNode(d.verified || 'Vérifié'));
    nm.appendChild(ver); w.appendChild(nm); w.appendChild(el('p', 'vt-review__src', 'Avis vérifié'));
    head.appendChild(w); a.appendChild(head);
    a.appendChild(starsNode(d.star, r.star || 5, 13));
    a.appendChild(el('p', 'vt-ritem__text', (r.content || '').trim()));
    const res = (r.resources || []).filter((x) => x.resource_type === 1).slice(0, 4);
    if (res.length) {
      const ph = el('div', 'vt-ritem__photos');
      res.forEach((x) => { const s = el('a'); s.href = x.src; s.setAttribute('data-vt-zoom', x.src); s.setAttribute('aria-label', 'Agrandir la photo de ' + name); const im = el('img'); im.src = x.thumb_src || x.src; im.alt = 'Photo de ' + name; im.loading = 'lazy'; s.appendChild(im); ph.appendChild(s); });
      a.appendChild(ph);
    }
    const f = el('div', 'vt-ritem__foot'); f.appendChild(el('span', null, d.helpfulQ || 'Cet avis est utile ?'));
    const h = el('button', 'vt-review__helpful'); h.type = 'button'; h.dataset.count = r.likes_count || 0;
    h.appendChild(document.createTextNode((d.helpful || 'Oui') + ' · ')); h.appendChild(el('span', null, String(r.likes_count || 0))).setAttribute('data-n', '');
    f.appendChild(h); a.appendChild(f);
    return a;
  }
  function bindHelpful(b) {
    if (b.dataset.bound) return; b.dataset.bound = '1';
    b.addEventListener('click', () => {
      const voted = b.classList.toggle('is-voted');
      const n = parseInt(b.dataset.count || '0', 10) + (voted ? 1 : 0);
      $('[data-n]', b).textContent = n;
    });
  }
  function initReviews() {
    $$('[data-vt-reviews]').forEach((sec) => {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      let key = 'all';
      const applyFilter = () => {
        $$('.vt-review', sec).forEach((c) => {
          const tags = (c.dataset.tags || '').split(',');
          c.hidden = !(key === 'all' || tags.includes(key));
        });
      };
      $$('.vt-filter', sec).forEach((f) => f.addEventListener('click', () => {
        $$('.vt-filter', sec).forEach((x) => { x.classList.toggle('is-active', x === f); x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
        key = f.dataset.filter; applyFilter();
      }));
      $$('.vt-review__helpful', sec).forEach(bindHelpful);
      const list = $('.vt-review-list, .vt-rlist__items', sec);
      const dotsWrap = $('.vt-dots', sec);
      const syncDots = () => {
        if (!dotsWrap || !list) return;
        const n = Math.min(8, $$('.vt-review', list).filter((c) => !c.classList.contains('vt-review--d') && !c.hidden).length);
        if (dotsWrap.children.length !== n) { dotsWrap.innerHTML = ''; for (let i = 0; i < n; i++) dotsWrap.appendChild(el('i', i === 0 ? 'is-active' : null)); }
      };
      if (list && dotsWrap) {
        list.addEventListener('scroll', () => {
          const dots = $$('i', dotsWrap);
          const max = list.scrollWidth - list.clientWidth;
          const i = max > 0 ? Math.round((list.scrollLeft / max) * (dots.length - 1)) : 0;
          dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        }, { passive: true });
      }
      // Live Trustoo reviews
      /* Only real product reviews: verified, 4-5 stars, a real sentence, no order/delivery/address messages */
      const offTopic = /(commande|command[eé]|confirmation|livr|colis|adresse|habite|re[çc]u|exp[ée]di|suivi|rembours|r[ée]ponse|contact|mail|num[ée]ro|factur|annul|retour|pas encore|toujours pas|arnaque|\?)/i;
      const goodReview = (r) => { const c = (r.content || '').trim(); return r.verified_badge === 1 && (r.star || 0) >= 4 && c.length >= 25 && !offTopic.test(c); };
      const pid = sec.dataset.trustoo;
      if (!pid || !list) return;
      const limit = parseInt(sec.dataset.trustooLimit || '4', 10);
      const isList = sec.dataset.trustooStyle === 'list';
      const more = $('[data-vt-more]', sec);
      let page = 0; let total = 1; const queue = [];
      const fetchPage = async () => {
        page += 1;
        const url = `https://api.trustoo.io/api/v1/reviews/get_product_reviews?shop_id=${sec.dataset.trustooShop}&limit=7&page=${page}&product_id=${pid}&sort_by=commented-at-descending`;
        const j = await (await fetch(url)).json();
        const data = (j && j.data) || {};
        total = (data.page && data.page.total_page) || page;
        (data.list || []).filter(goodReview).forEach((r) => queue.push(r));
      };
      const show = async (n) => {
        try {
          while (queue.length < n * 2 && page < total) await fetchPage();
          queue.sort((a, b) => ((b.resources || []).length > 0) - ((a.resources || []).length > 0));
        } catch (e) { return; }
        queue.splice(0, n).forEach((r) => { const c = isList ? cardList(sec, r) : cardGrid(sec, r); list.appendChild(c); $$('.vt-review__helpful', c).forEach(bindHelpful); });
        applyFilter(); syncDots();
        if (more && page >= total && !queue.length) more.hidden = true;
      };
      if (more) more.addEventListener('click', () => { more.classList.add('is-loading'); show(limit).finally(() => more.classList.remove('is-loading')); });
      const start = () => show(limit);
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((e) => { if (e[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '600px' });
        io.observe(sec);
      } else start();
    });
  }

  /* Photo viewer for review pictures */
  function initZoom() {
    let dlg = null;
    const open = (src, alt) => {
      if (!dlg) {
        dlg = document.createElement('dialog'); dlg.className = 'vt-s vt-zoom';
        dlg.innerHTML = '<button type="button" class="vt-zoom__close" aria-label="Fermer">\u2715</button><img alt="">';
        document.body.appendChild(dlg);
        dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('.vt-zoom__close')) dlg.close(); });
        dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
      }
      const im = dlg.querySelector('img'); im.src = src; im.alt = alt || '';
      if (dlg.showModal) { dlg.showModal(); document.documentElement.style.overflow = 'hidden'; } else window.open(src, '_blank');
    };
    document.addEventListener('click', (e) => {
      const z = e.target.closest('[data-vt-zoom]'); if (!z) return;
      e.preventDefault(); const im = z.querySelector('img'); open(z.getAttribute('data-vt-zoom'), im && im.alt);
    });
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-vt-zoom]')) { e.preventDefault(); e.target.click(); }
    });
  }

  /* Modals (ingredients list) */
  function initModals() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-vt-modal-open]');
      if (opener) {
        const d = document.getElementById(opener.dataset.vtModalOpen);
        if (d && d.showModal) { d.showModal(); document.documentElement.style.overflow = 'hidden'; }
        return;
      }
      const dlg = e.target.closest('dialog.vt-modal');
      if (e.target.closest('[data-vt-modal-close]') || (dlg && e.target === dlg)) { dlg.close(); }
    });
    $$('dialog.vt-modal').forEach((d) => d.addEventListener('close', () => { document.documentElement.style.overflow = ''; }));
  }

  /* Accordions: one open at a time */
  function initAccordions() {
    $$('[data-vt-acc]').forEach((acc) => {
      $$('details', acc).forEach((d) => d.addEventListener('toggle', () => {
        if (d.open) $$('details', acc).forEach((o) => { if (o !== d) o.open = false; });
      }));
    });
  }


  /* Tabs */
  function initTabs() {
    $$('[data-vt-tabs]').forEach((sec) => {
      const tabs = $$('[role="tab"]', sec);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); select(n);
        });
      });
    });
  }

  /* Sticky add-to-cart (mobile) */
  function initSticky() {
    $$('[data-vt-sticky]').forEach((bar) => {
      const sec = bar.closest('section');
      const form = $('[data-vt-buy]', sec);
      const btn = form && $('[data-vt-add]', form);
      if (!btn) return;
      const sync = () => {
        const pack = $('input[name="vt-pack"]:checked', form);
        if (!pack) return;
        $('[data-vt-sticky-name]', bar).textContent = pack.dataset.stickyName || '';
        $('[data-vt-sticky-price]', bar).textContent = pack.dataset.stickyPrice || '';
      };
      $$('input[name="vt-pack"]', form).forEach((i) => i.addEventListener('change', sync));
      sync();
      $('[data-vt-sticky-add]', bar).addEventListener('click', () => btn.click());
      if (!('IntersectionObserver' in window)) return;
      let pastButton = false;
      new IntersectionObserver(([e]) => {
        pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', pastButton);
        bar.setAttribute('aria-hidden', pastButton ? 'false' : 'true');
        $('[data-vt-sticky-add]', bar).tabIndex = pastButton ? 0 : -1;
      }).observe(btn);
    });
  }

  document.addEventListener('click', (e) => {
    const proxy = e.target.closest('[data-vt-add-proxy]');
    const btn = proxy && $('[data-vt-add]');
    if (!btn) return;
    e.preventDefault();
    btn.click();
  });

  const init = () => {
    initCountdowns();
    initMarquees();
    initDrawer();
    initGalleries();
    initCart();
    initVip();
    initZoom();
    try {
      const q = new URLSearchParams(location.search);
      if (q.has('vt_cart')) {
        q.delete('vt_cart'); const qs = q.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
        if (cartEl()) openCart();
      }
    } catch (e) {}
    initMega();
    initLegal();
    initBuy();
    initReviews();
    initAccordions();
    initTabs();
    initSticky();
    initModals();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { initMarquees(); initGalleries(); initBuy(); initReviews(); initAccordions(); });
})();
